export default {
	getAgenda: (state) => state.agenda,
	getAgendaDate: (state) => state.date,
	getAgendaHumor: (state) => state.agenda.humor,
	getAdditionalMeals: (state) => state.agenda.additionalMeals,
	getAgendaRegularMedicines: (state) => state.agenda.regularMedicines,
	getAgendaScheduledHomework: (state) => state.agenda.scheduledHomework,
	getAgendaSleepy: (state) => state.agenda.sleepy,
	getAgendaCompletionStatus: (state) => state.completionStatus,
	getAgendaExclusiveHomework: (state) => state.agenda.exclusiveHomework,
	getReplacementItens: (state) => state.agenda.replacementItens
};



// WEBPACK FOOTER //
// ./sources/app/agenda/getters.js